export default "__VITE_ASSET__BB0flpzB__"